import { apiInstance } from '../base';
import type { ResponseObject } from '../types';
import type { ITwitterProfile } from './types';

const BASE_URL = '/twitter';

export const getMyTwitterProfile = (): Promise<
  ResponseObject<ITwitterProfile>
> => {
  return apiInstance.get(`${BASE_URL}/profile/me`).then((response) => {
    return response.data;
  });
};
